import React from 'react';
import { useProperty } from '../context/PropertyContext';

const ProjectsSection = () => {
  const { projects } = useProperty();

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div 
          className="section-header"
        >
          <div className="section-badge">OUR PROJECTS</div>
          <h2>Transforming Landscapes, Creating Dreams</h2>
          <p>Explore our portfolio of exceptional real estate projects across Bangalore, each designed with precision and built with excellence.</p>
        </div>

        <div className="projects-slider">
          <div className="projects-track">
            {/* First set of projects */}
            {projects.map((project) => (
              <div key={project.id} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <div className="project-status">
                      <span className={`status-badge ${project.status.toLowerCase()}`}>
                        {project.status}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p className="project-location">
                    <i className="fas fa-map-marker-alt"></i>
                    {project.location}
                  </p>
                  <div className="project-details">
                    <span className="project-type">{project.type}</span>
                    <span className="project-units">{project.units}</span>
                  </div>
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {projects.map((project) => (
              <div key={`${project.id}-duplicate`} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <div className="project-status">
                      <span className={`status-badge ${project.status.toLowerCase()}`}>
                        {project.status}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p className="project-location">
                    <i className="fas fa-map-marker-alt"></i>
                    {project.location}
                  </p>
                  <div className="project-details">
                    <span className="project-type">{project.type}</span>
                    <span className="project-units">{project.units}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div 
          className="projects-cta"
        >
          <h3>Ready to Start Your Dream Project?</h3>
          <p>Let's discuss your vision and bring it to life with our expertise and commitment to excellence.</p>
          <button 
            className="btn-luxhom-contact"
            onClick={() => {
              const message = `Hi! I'm interested in discussing a new real estate project with TrueHome Properties.

I would like to know more about:
- Project development services
- Investment opportunities
- Custom property solutions
- Timeline and pricing

Please contact me to schedule a consultation.`;
              
              const whatsappURL = `https://wa.me/919187458799?text=${encodeURIComponent(message)}`;
              window.open(whatsappURL, '_blank');
            }}
          >
            <i className="fab fa-whatsapp"></i>
            <span>Discuss Your Project</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;